import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { ProcedureQueryParams } from './hooks/useFetchProcedures';
import FilterBox from 'components/filter-box/FilterBox';
import CpfCnpjInput from 'components/masked-input/CpfCnpjInput';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 100px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type ProcedureFilterBoxProps = {
  filter: ProcedureQueryParams;
  handleChange<K extends keyof ProcedureQueryParams>(index: K, value: ProcedureQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const ProcedureFilterBox: React.FC<ProcedureFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome da consulta"
          placeholder="Digite o nome da consulta"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default ProcedureFilterBox;
